<template>
  <div>
    <el-card class="box-card" v-if="permissions.indexOf('列表') > -1">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="资源名称" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入资源名称" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="功能" prop="function">
              <el-select v-model="searchForm.function" placeholder="请输入功能">
                <el-option v-for="item in functions" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="资源路径" prop="url">
              <el-input v-model="searchForm.url" placeholder="请输入资源路径" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <a class="mainColor mr" @click="reset" icon="el-icon-refresh">重置</a>
            <el-button :size="buttonSize" type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <!-- <el-button :size="buttonSize" type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            :size="buttonSize"
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
            v-if="permissions.indexOf('新增') > -1"
          >新增</el-button>
          <el-button
            :size="buttonSize"
            type="danger"
            @click="batchDeleteResource"
            icon="el-icon-minus"
            v-if="permissions.indexOf('批量删除') > -1"
          >批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button
            :size="buttonSize"
            type="primary"
            @click="importFormVisible = true"
            icon="el-icon-download"
            v-if="permissions.indexOf('导入') > -1"
          >导入</el-button>
          <el-button
            :size="buttonSize"
            style="text-align: right"
            type="primary"
            @click="exportExcel"
            :loading="loading"
            icon="el-icon-upload2"
            v-if="permissions.indexOf('导出') > -1"
          >导出</el-button>
        </el-col>
      </el-row>
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        @selection-change="selectionChange"
        v-if="permissions.indexOf('列表') > -1"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="module" label="模块"></el-table-column>
        <el-table-column prop="name" label="资源名称"></el-table-column>
        <el-table-column prop="function" label="功能"></el-table-column>
        <el-table-column prop="url" label="资源路径"></el-table-column>
        <el-table-column prop="icon" label="图标">
          <template slot-scope="scope">
            <i :class="scope.row.icon"></i>
          </template>
        </el-table-column>
        <el-table-column prop="sequence" label="排序"></el-table-column>
        <el-table-column prop label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div class="operation-group">
              <span
                @click="selection = scope.row.id, editFormVisible = true"
                v-if="permissions.indexOf('编辑') > -1"
              >
                <i class="el-icon-edit"></i>编辑
              </span>
              <span @click="deleteResource(scope.row)" v-if="permissions.indexOf('删除') > -1">
                <i class="el-icon-delete"></i>删除
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
        v-if="permissions.indexOf('列表') > -1"
      ></el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" left v-if="permissions.indexOf('新增') > -1">
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-form-item label="父级资源" prop="parentId">
          <el-tree-select
            v-model="addForm.parentId"
            :styles="styles"
            :selectParams="selectParams"
            :treeParams="treeParams"
            @node-click="selectAddFormModule"
            ref="treeSelect"
          />
        </el-form-item>
        <el-form-item v-show="false" label="模块" prop="module">
          <el-input v-model="addForm.module" placeholder="请输入模块" auto-complete="off" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="资源名称" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入资源名称" auto-complete="off" maxlength="32"></el-input>
        </el-form-item>
        <el-form-item label="功能" prop="function">
          <el-select v-model="addForm.function" placeholder="请输入功能">
            <el-option v-for="item in functions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源路径" prop="url">
          <el-input v-model="addForm.url" placeholder="请输入资源路径" auto-complete="off" maxlength="512"></el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon" style="height: 200px;overflow: auto">
          <i
            v-for="icon in iconArray"
            :class="icon"
            :style="addForm.icon == icon ? 'border: 1px solid #111;font-size: 20px;' : 'border: 0px;font-size: 20px;'"
            @click="selectIcon('add', $event)"
          ></i>
        </el-form-item>
        <el-form-item label="状态" prop="active">
          <el-radio v-model="addForm.active" :label="1">启用</el-radio>
          <el-radio v-model="addForm.active" :label="-1">禁用</el-radio>
        </el-form-item>
        <el-form-item label="排序" prop="sequence">
          <el-input
            type="number"
            v-model.number="addForm.sequence"
            placeholder="请输入排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="addResource">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      left
      v-if="permissions.indexOf('编辑') > -1"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-form-item label="父级资源" prop="parentId">
          <el-tree-select
            v-model="editForm.parentId"
            :styles="styles"
            :selectParams="selectParams"
            :treeParams="treeParams"
            @node-click="selectEditFormModule"
            ref="treeSelect"
          />
        </el-form-item>
        <el-form-item v-show="false" label="模块" prop="module">
          <el-input
            v-model="editForm.module"
            placeholder="请输入模块"
            auto-complete="off"
            maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item label="资源名称" prop="name">
          <el-input
            v-model="editForm.name"
            placeholder="请输入资源名称"
            auto-complete="off"
            maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item label="功能" prop="function">
          <el-select v-model="editForm.function" placeholder="请输入功能">
            <el-option v-for="item in functions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源路径" prop="url">
          <el-input
            v-model="editForm.url"
            placeholder="请输入资源路径"
            auto-complete="off"
            maxlength="512"
          ></el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon" style="height: 200px;overflow: auto">
          <i
            v-for="icon in iconArray"
            :class="icon"
            :style="editForm.icon == icon ? 'border: 1px solid #111;font-size: 20px;' : 'border: 0px;font-size: 20px;'"
            @click="selectIcon('edit', $event)"
          ></i>
        </el-form-item>
        <el-form-item label="状态" prop="active">
          <el-radio v-model="editForm.active" :label="1">启用</el-radio>
          <el-radio v-model="editForm.active" :label="-1">禁用</el-radio>
        </el-form-item>
        <el-form-item label="排序" prop="sequence">
          <el-input
            type="number"
            v-model.number="editForm.sequence"
            placeholder="请输入排序"
            auto-complete="off"
            maxlength="10"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="buttonSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="buttonSize" type="primary" @click="updateResource">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="导入"
      :visible.sync="importFormVisible"
      width="80%"
      left
      v-if="permissions.indexOf('导入') > -1"
    >
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="buttonSize" size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="module" label="模块"></el-table-column>
        <el-table-column prop="name" label="资源名称"></el-table-column>
        <el-table-column prop="function" label="功能"></el-table-column>
        <el-table-column prop="url" label="资源路径"></el-table-column>
        <el-table-column prop="icon" label="图标"></el-table-column>
        <el-table-column prop="sequence" label="排序"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="buttonSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
        >导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      iconArray: [
        "el-icon-third-zhtn",
        "el-icon-third-commodity",
        "el-icon-third-int",
        "el-icon-third-tools",
        "el-icon-third-supply",
        "el-icon-third-questions",
        "el-icon-third-qianniudaidise",
        "el-icon-third-budaidise",
        "el-icon-third-decoration_fill",
        "el-icon-third-shake",
        "el-icon-third-marketing_fill",
        "el-icon-third-financial_fill",
        "el-icon-third-wangwang",
        "el-icon-third-unfold",
        "el-icon-third-packup",
        "el-icon-third-transaction_fill",
        "el-icon-third-shop_fill",
        "el-icon-third-publishgoods_fill",
        "el-icon-third-qianniu",
        "el-icon-third-searchfill",
        "el-icon-third-search",
        "el-icon-third-workbench",
        "el-icon-third-workbench_fill",
        "el-icon-third-warning",
        "el-icon-third-warning_fill",
        "el-icon-third-video_fill",
        "el-icon-third-video",
        "el-icon-third-unlock",
        "el-icon-third-unlock_fill",
        "el-icon-third-undo",
        "el-icon-third-trash_fill",
        "el-icon-third-trash",
        "el-icon-third-translation",
        "el-icon-third-translation_fill",
        "el-icon-third-time",
        "el-icon-third-time_fill",
        "el-icon-third-text",
        "el-icon-third-tasklist",
        "el-icon-third-tasklist_fill",
        "el-icon-third-task_fill",
        "el-icon-third-task",
        "el-icon-third-tailor",
        "el-icon-third-systemprompt",
        "el-icon-third-systemprompt_fill",
        "el-icon-third-switch",
        "el-icon-third-suspend",
        "el-icon-third-success",
        "el-icon-third-success_fill",
        "el-icon-third-stealth",
        "el-icon-third-stealth_fill",
        "el-icon-third-smallscreen",
        "el-icon-third-smallscreen_fill",
        "el-icon-third-shielding",
        "el-icon-third-shielding_fill",
        "el-icon-third-share",
        "el-icon-third-share_fill",
        "el-icon-third-setup",
        "el-icon-third-setup_fill",
        "el-icon-third-service",
        "el-icon-third-service_fill",
        "el-icon-third-send",
        "el-icon-third-select",
        "el-icon-third-select_fill",
        "el-icon-third-scan",
        "el-icon-third-right",
        "el-icon-third-return",
        "el-icon-third-remind",
        "el-icon-third-remind_fill",
        "el-icon-third-refresh",
        "el-icon-third-redpacket",
        "el-icon-third-redpacket_fill",
        "el-icon-third-qrcode",
        "el-icon-third-qrcode_fill",
        "el-icon-third-prompt",
        "el-icon-third-prompt_fill",
        "el-icon-third-praise",
        "el-icon-third-praise_fill",
        "el-icon-third-playon",
        "el-icon-third-playon_fill",
        "el-icon-third-play_fill",
        "el-icon-third-play",
        "el-icon-third-picture",
        "el-icon-third-picture_fill",
        "el-icon-third-people",
        "el-icon-third-people_fill",
        "el-icon-third-other",
        "el-icon-third-order",
        "el-icon-third-order_fill",
        "el-icon-third-offline",
        "el-icon-third-offline_fill",
        "el-icon-third-narrow",
        "el-icon-third-more",
        "el-icon-third-mobilephone",
        "el-icon-third-mobilephone_fill",
        "el-icon-third-mine_fill",
        "el-icon-third-mine",
        "el-icon-third-message_fill",
        "el-icon-third-message",
        "el-icon-third-manage",
        "el-icon-third-manage_fill",
        "el-icon-third-mail_fill",
        "el-icon-third-mail",
        "el-icon-third-lock",
        "el-icon-third-lock_fill",
        "el-icon-third-live",
        "el-icon-third-live_fill",
        "el-icon-third-like",
        "el-icon-third-like_fill",
        "el-icon-third-label_fill",
        "el-icon-third-label",
        "el-icon-third-keyboard",
        "el-icon-third-interactive",
        "el-icon-third-interactive_fill",
        "el-icon-third-integral",
        "el-icon-third-integral_fill",
        "el-icon-third-homepage",
        "el-icon-third-homepage_fill",
        "el-icon-third-headlines",
        "el-icon-third-headlines_fill",
        "el-icon-third-group_fill",
        "el-icon-third-group",
        "el-icon-third-fullscreen",
        "el-icon-third-flip_fill",
        "el-icon-third-flip",
        "el-icon-third-flashlight_fill",
        "el-icon-third-flashlight",
        "el-icon-third-flag",
        "el-icon-third-flag_fill",
        "el-icon-third-feedback",
        "el-icon-third-feedback_fill",
        "el-icon-third-enterinto_fill",
        "el-icon-third-enterinto",
        "el-icon-third-enter",
        "el-icon-third-empty_fill",
        "el-icon-third-empty",
        "el-icon-third-emoji",
        "el-icon-third-emoji_fill",
        "el-icon-third-eit",
        "el-icon-third-editor",
        "el-icon-third-dynamic",
        "el-icon-third-dynamic_fill",
        "el-icon-third-document_fill",
        "el-icon-third-document",
        "el-icon-third-delete",
        "el-icon-third-delete_fill",
        "el-icon-third-customerservice",
        "el-icon-third-customerservice_fill",
        "el-icon-third-createtask",
        "el-icon-third-createtask_fill",
        "el-icon-third-coupons",
        "el-icon-third-coupons_fill",
        "el-icon-third-coordinates",
        "el-icon-third-coordinates_fill",
        "el-icon-third-computer",
        "el-icon-third-computer_fill",
        "el-icon-third-collection",
        "el-icon-third-collection_fill",
        "el-icon-third-close",
        "el-icon-third-clock",
        "el-icon-third-clock_fill",
        "el-icon-third-camera",
        "el-icon-third-camera_fill",
        "el-icon-third-businesscard",
        "el-icon-third-businesscard_fill",
        "el-icon-third-brush_fill",
        "el-icon-third-brush",
        "el-icon-third-browse",
        "el-icon-third-browse_fill",
        "el-icon-third-barrage",
        "el-icon-third-barrage_fill",
        "el-icon-third-addressbook",
        "el-icon-third-addressbook_fill",
        "el-icon-third-addpeople",
        "el-icon-third-addpeople_fill",
        "el-icon-third-addition",
        "el-icon-third-addition_fill",
        "el-icon-third-add",
        "el-icon-third-activity_fill",
        "el-icon-third-activity",
        "el-icon-third-accessory"
      ],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        name: "",
        function: "",
        url: ""
      },
      styles: {
        width: "300px"
      },
      selectParams: {
        clearable: true,
        placeholder: "请选择资源"
      },
      treeParams: {
        clickParent: true,
        filterable: false,
        "check-strictly": true,
        "default-expand-all": false,
        "expand-on-click-node": false,
        data: [],
        props: {
          children: "resources",
          label: "name",
          disabled: "disabled",
          value: "id"
        }
      },
      addForm: {
        parentId: "",
        module: "",
        name: "",
        function: "",
        url: "",
        icon: "",
        active: 1,
        sequence: 0
      },
      addFormRules: {
        parentId: [
          {
            required: true,
            message: "请输入父级资源id",
            trigger: "blur"
          },
          {
            pattern: /^-?\d+$/,
            message: "父级资源id格式不正确"
          }
        ],
        module: [
          {
            required: true,
            message: "请输入模块",
            trigger: "blur"
          },
          {
            min: 1,
            max: 32,
            message: "模块长度在1到32个字"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入资源名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 32,
            message: "资源名称长度在1到32个字"
          }
        ],
        function: [
          {
            required: true,
            message: "请输入功能",
            trigger: "change"
          }
        ],
        url: [
          {
            required: false,
            message: "请输入资源路径",
            trigger: "blur"
          },
          {
            min: 0,
            max: 512,
            message: "资源路径长度在1到512个字"
          }
        ],
        icon: [
          {
            required: false,
            message: "请输入图标",
            trigger: "blur"
          },
          {
            min: 0,
            max: 48,
            message: "图标长度在1到48个字"
          }
        ],
        sequence: [
          {
            required: false,
            message: "请输入显示排序",
            trigger: "blur"
          },
          {
            pattern: /^-?\d+$/,
            message: "显示排序格式不正确"
          },
          {
            type: "integer",
            min: -2147483648,
            max: 2147483647,
            message: "输入值必须在-2147483648在2147483647之间"
          }
        ]
      },
      editForm: {
        parentId: "",
        module: "",
        name: "",
        function: "",
        url: "",
        icon: "",
        active: 1,
        sequence: 0
      },
      editFormRules: {
        parentId: [
          {
            required: true,
            message: "请输入父级资源id",
            trigger: "blur"
          },
          {
            pattern: /^-?\d+$/,
            message: "父级资源id格式不正确"
          }
        ],
        module: [
          {
            required: true,
            message: "请输入模块",
            trigger: "blur"
          },
          {
            min: 1,
            max: 32,
            message: "模块长度在1到32个字"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入资源名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 32,
            message: "资源名称长度在1到32个字"
          }
        ],
        function: [
          {
            required: true,
            message: "请输入功能",
            trigger: "blur"
          },
          {
            min: 1,
            max: 32,
            message: "功能长度在1到32个字"
          }
        ],
        url: [
          {
            required: false,
            message: "请输入资源路径",
            trigger: "blur"
          },
          {
            min: 0,
            max: 512,
            message: "资源路径长度在1到512个字"
          }
        ],
        icon: [
          {
            required: false,
            message: "请输入图标",
            trigger: "blur"
          },
          {
            min: 0,
            max: 48,
            message: "图标长度在1到48个字"
          }
        ],
        sequence: [
          {
            required: false,
            message: "请输入显示排序",
            trigger: "blur"
          },
          {
            pattern: /^-?\d+$/,
            message: "显示排序格式不正确"
          },
          {
            type: "integer",
            min: -2147483648,
            max: 2147483647,
            message: "输入值必须在-2147483648在2147483647之间"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/resource/upload`,
      fileList: [],
      loading: false,
      permissions: [],
      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      functions: [
        "菜单",
        "页面",
        "接口",
        "新增",
        "编辑",
        "删除",
        "批量删除",
        "搜索",
        "重置",
        "树",
        "获取详情",
        "获取集合",
        "导入",
        "导出",
        "立即执行",
        "恢复",
        "暂停",
        "文件配置",
        "生成文件",
        "规则配置",
        "复制抄表",
        "抄表录入"
      ]
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    getResource() {
      this.api.resource
        .getResource({ id: this.selection })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.agentId = this.loginData.agentId;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.resource
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          this.loading = false;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addResource() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.resource
            .addResource(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateResource() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.resource
            .updateResource(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteResource(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.resource
            .deleteResource([
              {
                id: row.id
              }
            ])
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteResource() {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.resource
            .deleteResource(this.ids)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.resource
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.resource
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user);
      user.resources.forEach(e => {
        e.resources.forEach(a => {
          if (a.url == this.$route.path) {
            a.resources.forEach(e => this.permissions.push(e.function));
          }
        });
      });
    },
    getResourceTree() {
      this.api.resource
        .getResourceTree()
        .then(result => {
          this.treeParams.data = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    selectAddFormModule(data, node, vm) {
      this.addForm.module = node.label;
    },
    selectEditFormModule(data, node, vm) {
      this.editForm.module = node.label;
    },
    selectIcon(form, event) {
      let el = event.currentTarget;
      if (form == "add") {
        this.addForm.icon = el.className;
      } else {
        this.editForm.icon = el.className;
      }
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getResource();
      }
    }
  },
  mounted() {
    this.getPermissionList();
    this.pageList();
    this.getResourceTree();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/resource/index.vue